import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentLanguage } from '@/modules//language/useCurrentLanguage';
import { RQ_X_COUNTRY_CODE } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { similarItemsQueryOptions } from '@/modules/similar/queries';
import { type FetchSimilarItemsQueryParams } from '@/modules/similar/types';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useSimilarItems({
  productId,
  params,
  enabled = true,
}: {
  productId?: number;
  params?: Partial<FetchSimilarItemsQueryParams>;
  enabled?: boolean;
}) {
  const { language } = useCurrentLanguage();
  const { location } = useCurrentLocation();
  const [, user] = useCurrentUser();
  const queryClient = useQueryClient();
  const buyerCountry = user
    ? user.country
    : queryClient.getQueryData<string>([RQ_X_COUNTRY_CODE]);

  return useQuery(
    similarItemsQueryOptions({
      productId,
      params: {
        ...params,
        country: location,
        lang: language,
        hide_sold_products: true,
        include_like_count: true,
      },
      withAuth: Boolean(user?.id),
      buyerCountry,
      enabled,
    })
  );
}
